import React from 'react';
import { Link } from 'react-router-dom';

const products = [
  {
    title: 'Site Office / Farm House Cottage',
    description:
      'Prefabricated site offices and farm house cottages designed for a comfortable, professional workspace. Built with cement board, false ceiling, doors, windows, and electric fittings for durability and weather resistance.',
    image: '/products/projects/image1.jpeg',
  },
  {
    title: 'Servant Room with Front Elevation',
    description:
      'A beautifully crafted rooftop retreat wrapped in warm wood-look panelling and sleek glass finishes. Built with cement board, false ceiling, doors, windows, and electric fittings.',
    image: '/products/projects/image2.jpeg',
  },
  {
    title: 'Site Office',
    description:
      'Framed by reflective dark cladding and pristine paving, our site office makes a bold professional statement. Built with cement board, false ceiling, ACP sheet, glass work, glass door, and electric fittings.',
    image: '/products/projects/image3.jpeg',
  },
  {
    title: 'Cafeteria On Roof',
    description:
      'Equipped with wide sliding entry doors and ample surrounding space to streamline on-site operations. Built with cement board flooring, false ceiling, ACP sheet, glass work, glass door, sliding windows, and electric fittings.',
    image: '/products/projects/image4.jpeg',
  },
  {
    title: 'Puff Panel Guard Cabin / Security Room',
    description:
      'Built with high-density PUFF sandwich panels for superior thermal insulation and weather resistance. Features a durable structural frame and clear sliding windows — a quick-to-deploy secure monitoring station.',
    image: '/products/projects/image5.jpeg',
  },
  {
    title: 'ATM Kiosk',
    description:
      'Engineered with premium ACP cladding, a sturdy elevated base, and a sleek glass entrance door. Fully equipped with electrical fittings for a safe, weather-resistant plug-and-play ATM solution.',
    image: '/products/projects/image6.jpeg',
  },
  {
    title: 'Guard Cabin',
    description:
      'Durable, weather-resistant guard rooms for security personnel. Built with ACP sheet / cement board and puff panel, with door and aluminium sliding windows — ideal for commercial, industrial, and construction sites.',
    image: '/products/projects/image7.jpeg',
  },
  {
    title: 'Reception Area (Entry Gate)',
    description:
      'Heavy-duty MS pipe framework with premium ACP sheet cladding for high structural strength and a striking exterior. Integrated aluminium tube detailing and recessed LED fittings for a clean, well-lit commercial entrance.',
    image: '/products/projects/image8.jpeg',
  },
];

function ProductServices() {
  return (
    <div className="page">
      <header className="page-header">
        <span className="page-eyebrow">What We Offer</span>
        <h1 className="page-title">Products & Services</h1>
        <p className="page-subtitle">
          From site offices and farm house cottages to guard cabins, ATM kiosks, and reception
          structures — engineered for your exact requirements.
        </p>
      </header>

      <div className="products-grid">
        {products.map((product) => (
          <article key={product.title} className="product-card">
            <div className="product-card-image">
              <img src={product.image} alt={product.title} />
            </div>
            <div className="product-card-body">
              <h3>{product.title}</h3>
              <p>{product.description}</p>
            </div>
          </article>
        ))}
      </div>

      <section className="cta-band" style={{ marginTop: '3rem' }}>
        <h2>Need a Custom Solution?</h2>
        <p>Every project is unique. Share your requirements and we&apos;ll design a prefab system tailored to you.</p>
        <Link to="/contact" className="btn btn-primary">
          Request a Quote
        </Link>
      </section>
    </div>
  );
}

export default ProductServices;
